export default __webpack_public_path__ + "media/siteware_admin/favicon-196-c250b30ac30ffcc57c76d328ae835c37.png";